var chatTypes_VoteType = /*#__PURE__*/ function(VoteType) {
    VoteType["NONE"] = "NONE";
    VoteType["UP"] = "UP";
    VoteType["DOWN"] = "DOWN";
    return VoteType;
}({});
export { chatTypes_VoteType as VoteType };
